module.exports = __webpack_public_path__ + "static/flags/BM-22fdf245937f244d931e6bc3c5f6adb3.gif";